module.exports = __webpack_public_path__ + "img/nextpage.3799686c.svg";